import { useCallback, useEffect, useState } from "react";
import { adminService } from "apiServices/apiController/adminService";

export const useMasterData = ({ fetchCompany = false } = {}) => {
  const [companyOptions, setCompanyOptions] = useState([]);
  const [loadingMasterData, setLoadingMasterData] = useState(true);

  const fetchAllMasterData = useCallback(async () => {
    const promises = [];

    if (fetchCompany) {
      promises.push(
        adminService.GET_COMPANY_USER_COUNTS().then((res) => {
          if (res?.success) {
            setCompanyOptions(
              res.data.map((item) => ({
                label: `${item.name} (${item.user_count ?? 0})`,
                value: item.id,
              }))
            );
          }
        })
      );
    }

    await Promise.all(promises);
    setLoadingMasterData(false);
  }, [fetchCompany]);

  useEffect(() => {
    fetchAllMasterData();
  }, [fetchAllMasterData]);

  return { companyOptions, loadingMasterData };
};
